var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeScreen === _vm.ScreensEnum.chatPopup
    ? _c("div", { staticClass: "well well-sm chat-toggle-popover" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn branding-background branding-text",
            attrs: { id: "" },
            on: {
              click: function ($event) {
                return _vm.nextScreen(_vm.ScreensEnum.startConversation)
              },
            },
          },
          [_vm._v("Let's Chat")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "", title: "Hide Chat" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.nextScreen(_vm.ScreensEnum.chatButton)
              },
            },
          },
          [_vm._v("Maybe Later")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }